function ReportGeneration() {
	/// <summary>
	/// This object provides client-side functions for the Widget.Report.Generation visual. <br/>
	/// <br/>
	/// Author: MWI<br />
	/// Date: 21.09.2016<br />
	/// Copyright ©: EUDT GmbH 2016 <br />
	/// Version-History:<br />
	/// **********************************************************************<br />
	/// *** v1.0.0 - 09.01.2017                                               *<br />
	/// **********************************************************************<br />
	/// * - generation button now does nothing when disabled                 *<br />
	/// **********************************************************************<br />
	/// *** v1.0.0 - 12.05.2016                                               *<br />
	/// **********************************************************************<br />
	/// * - basic functionality                                              *<br />
	/// **********************************************************************<br />
	/// </summary>
	try {
		this.loggerId = -1;
		this.reportId = -1;
		// Object contains the steps for the wizard in the report 
		//object freeze fixes the object so it cannot be overriden during runtime
		//
		this.ENUM_STEPS = Object.freeze({
			SELECT_PROJECT: 0, SELECT_REPORT: 1, OPTIONS: 2, SAVE: 3, SEND_MAIL: 4
		});
		this.ENUM_CALLS = Object.freeze({ LOAD_REPORTS: 0, LOAD_LOGGER: 1, CHECK_DATA: 2, GENERATE: 3, SAVE: 4, LOAD_USER: 5, SEND_MAIL: 6, GET_ANNOT_COUNT: 7, LOAD_LOGGER_DDL: 8, LOAD_REPORTS_DDL: 9});
		this._FILEICONS = { "pdf": "<i class='fa fa-file-pdf fa-2x report-file' title='Pdf'></i>", "xlsx": "<i class='fa fa-file-excel fa-2x report-file' title='Excel'></i>", "xls": "<i class='fa fa-file-excel fa-2x' title='Excel'></i>" };
	} catch (ex) {
		this.ENUM_STEPS = { SELECT_PROJECT: 0, SELECT_REPORT: 1,OPTIONS: 2,SAVE: 3,SEND_MAIL: 4};
		this.ENUM_CALLS = { LOAD_REPORTS: 0, LOAD_LOGGER: 1, CHECK_DATA: 2, GENERATE: 3, SAVE: 4, LOAD_USER: 5, SEND_MAIL: 6, GET_ANNOT_COUNT: 7, LOAD_LOGGER_DDL: 8, LOAD_REPORTS_DDL: 9 };

	}
};
ReportGeneration.prototype = new window.vcTemplate();

ReportGeneration.prototype.init = function () {
	/// <summary>
	/// This function inits the the Object <br/>
	/// it adds the clickhandler, the filter and the caleander <br/>
	/// further, it loads the initial content
	/// </summary>
	var me = this;
	try {
		if (me.error) {
			return false;
		}
		me.showInfo("", "", false);
		me.initClickHandler();
		
		me.fetchLogger();

		
		me.MainContent = me.visual.find(".report-main-content");
	
		me.MainContent.height(me.visual.height() - 50);

		me.visual.find("#logger, #lst-reports").css("max-height", me.MainContent.height() - 80);

		me.createdContent = me.visual.find("#report-generation-created-content");
		me.dialogWidth = parseInt($(window).width() * 0.95, 10);
		me.dialogHeight = parseInt($(window).height() * 0.95, 10);

		me.dialogOptions = {
			autoOpen: false,
			modal: true,
			resizable: false,
			dialogClass: "saveDialog yform",
			width: me.dialogWidth,
			height: me.dialogHeight,
			buttons:[
				{
					text: me.resources.close,
					click: function () {
						$(this).dialog("destroy").remove();
					}
				}
			]
		};

		me.archiveParameter = {"datatype": 2,
			"FillNullValues": true,
			"ShowIntervention": false,
			"ShowInvalidValues": true,
			"dateUserDef": false,
			"separateDataAxis": false,
			"ShowPlotLines": true,
			"ShowExportIcons": false,
			"showInterventions": false,
			"UseSimpleBottomLegend": true
			};
		me.archiveSigParameter = JSON.stringify({ "series": [] });

	
		var wizWidth = 295;
		if (window.screen.width < 1250) {
			wizWidth = 288;
			me.visual.find(".report-generation.vc-grid-8col").width(window.screen.width);
		}
		me.wiz = $("#vc-wizard-report-gen").vcWizard({ stepWidth: wizWidth });		
	    me.visual.find("#date").vcDateBox({ mode: "Single", align: "center", interval: 3, langID: me.userLangidForCulture, defaultDate: window.moment().add(-1, "M").format("DD.MM.YYYY"), callback: function (obj) { me.date = obj.returnDates.to;		me.visual.find("#btnGenerate").button("enable");} });

		me.initialContent = me.createdContent.find("#report-help");
		me.visual.find("#report-button-change").button({ "disabled": "true" });
		me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });
		return true;
	} catch (ex) {
		me.writeError("ReportGeneration.init", ex);
		return false;
	}
};

ReportGeneration.prototype.initClickHandler = function () {
	/// <summary>
	/// Initializes the various click handler for the buttons
	/// </summary>
	var me = this;
	try {
		if (me.error) {
			return false;
		}
		me.isReports = true;
		me.visual.find("#logger .vc-list-item").off("click").on("click", function () { me.selectProject(me, this); });
		me.visual.find("#btnGenerate").button().off("click").on("click", function () { me.btnGenerateClick(me); });
		me.visual.find("#btnAnnot").button().off("click").on("click", function () { me.btnAnnotationsClick(me); });
		me.visual.find("#btnUsers").button().off("click").on("click", function () { me.loadUsers(false); });
		me.visual.find("#report-button-change").button().off("click").on("click", function () { me.btnChangeSheets(me) });

		return true;
	} catch (ex) {
		me.writeError('ReportGeneration.initClickHandler', ex);
		return false;
	}
};


ReportGeneration.prototype.doEvent = function (event) {
	/// <summary>
	/// Handles the annotation event count change event <br/>
	/// by requesting the new event count from the server <br/>
	/// </summary> 
	var me = this;
	try {
		if (event.msg === "ANNOTATION_COUNT_CHANGED") {
			window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, JSON.stringify(me.createParameterObject(me.ENUM_CALLS.GET_ANNOT_COUNT)), function(result) {
				me.visual.find("#annot-count").html(result.retHTML.rows[0].count);
			});
		}
	} catch (ex) {
		me.writeError("ReportGeneration.doEvent", ex);
	}
};



ReportGeneration.prototype.fetchLogger = function () {
	///<summary>
	///loads the logger for the reports
	///</summary>
	var me = this;
	var sTmp;
	try {
		if (me.error) return;
		window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'loadType': me.ENUM_CALLS.LOAD_LOGGER_DDL }), function (result) {
			if (result.retHTML === null) {
				me.showInfo(me.resources.noEntriesExist, "", false);
				me.visual.find("#vc-wizard-report-gen, .report-main-content, #report-button-change").hide();
				return false;
			}
			if (result.retHTML.rows === null) {
				me.showInfo(me.resources.noEntriesExist, "", false);
				me.visual.find("#vc-wizard-report-gen, .report-main-content, #report-button-change").hide();
				return false;
			}

			me.fillLoggerList(result.retHTML, false);
			
			return true;
		});
	} catch (ex1) {
		me.writeError("ReportGeneration.fetchLoggers", ex1);
	}
};







ReportGeneration.prototype.selectProject = function (me, element) {
	///<summary>
	///handles the button click of the left buttons
	///</summary>
	try {
		if (me.error) return;
		me.visual.find("#report-create").hide();
		me.visual.find("#divReportSearch").show();

		me.wiz.vcWizard("setActive", me.ENUM_STEPS.SELECT_REPORT);

		me.loggerId = parseInt($(element).data("id"));
		me.reportId = -1;

		me.visual.find("#lst-reports").html("<div class='note loading'>" + me.vcC.getLoadingIcon() + "</div>");
		window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ LoadType: me.ENUM_CALLS.LOAD_REPORTS_DDL, Loggerid: parseInt($(element).data("id")) }),
			function (result) {
				if (result.hasError === false) {
					me.fillReportList(result.retHTML);
				} else {
					me.showInfo(result.retHTML, "", true);
				}
			});



	} catch (ex) {
		me.writeError("ReportGeneration.selectProject", ex);
	}
};


ReportGeneration.prototype.selectReport = function (me, element) {
	///<summary>
	///handles the button click of the left buttons
	///</summary>
	try {
		if (me.error) return;
		me.visual.find("#btnGenerate").button("enable");
		me.warningInvalid = false;
		me.visual.find("#report-button-change").button("enable");

		me.visual.find("#lst-reports .vc-list-item").removeClass("button-toggle-active");
		$(element).addClass("button-toggle-active");
		me.visual.find("#us-count").html($(element).data("user"));
		me.visual.find("#chbOverwrite").prop("checked", $(element).data("overwrite"));
		me.createdContent.html(me.initialContent);
		me.visual.find("#annot-count").html($(element).data("anno"));
		me.visual.find("#report-create").show();
		//me.visual.find("#divReportSearch").show();
	
		me.wiz.vcWizard("setActive", me.ENUM_STEPS.OPTIONS);

		me.reportId = parseInt($(element).data("rrid"));
	

	} catch (ex) {
		me.writeError("ReportGeneration.selectReport", ex);
	}
};

ReportGeneration.prototype.btnAnnotationsClick = function (me) {
	///<summary>
	///handles the selection of a the annotations button
	///</summary>

	try {
		me.createdContent.html("<div class='note loading'>" + me.vcC.getLoadingIcon() +"</div>");

		me.vcVisual.addVisualContentByName("report-generation-created-conten", "FORM_REPORT_ANNOTATIONS", "t", '27.11.2015', 500, me.createdContent.width() - 20, JSON.stringify({ "loggerid": me.loggerId, "rrid": me.reportId }),"",1);
	} catch (ex1) {
		me.writeError("ReportGeneration.btnAnnotationsClick", ex1);
	}
};

ReportGeneration.prototype.btnChangeSheets = function (me) {
	///<summary>
	///handles the click of the chart ratios button
	///</summary>
	var diag, tempOpt, reportId, title;
	try {
		if (me.visual.find("#report-button-change").button("option", "disabled") === false) {
			diag = $("<div>").attr("id", "sheetDialog" + me.visual.find("#logger .vc-list-item.button-toggle-active").data("id"));

			if (me.isReports) {
				reportId = me.selRep.val();
				title = me.selRep.find("option:selected").html();
			} else {
				reportId = me.visual.find("#logger .vc-list-item.button-toggle-active").data("rrid");
				title = me.visual.find("#logger .vc-list-item.button-toggle-active .report-logger-name").html();
			}
			tempOpt = me.dialogOptions;
			tempOpt.title = me.resources.manageWorksheets + " - " + title;
			diag.dialog(tempOpt);
			diag.dialog("open");

			window.VisualCoreService.getVisualContentByName("WIDGET_REPORT_EXCEL_DETAILS", "sheetDialog" + me.visual.find("#logger .vc-list-item.button-toggle-active").data("id"), window.getCurrentTimestamp(), me.dialogHeight - 100, me.dialogWidth - 120, JSON.stringify({ "rrid": reportId }), "", 1,
				function (res) {
					diag.append(res);
				});
		}
	} catch (ex) {
		me.writeError('ReportGeneration.btnChartRatiosClick', ex);
	}
};

ReportGeneration.prototype.btnGenerateClick = function (me) {
	///<summary>
	///prepares the generation of the report by asking if it is really wanted to generate the report  if an error state is detetected <br/>
	/// or directly generates the report
	///</summary>
	try {
		if (me.visual.find("#btnGenerate").button("option","disabled") === false) {
			if (me.warningInvalid === true ||
				me.visual.find("#logger .vc-list-item.button-toggle-active").data("user") < 1) {
				//create the confirmation dialog
				var dialog = $("<div id='conf'>" + me.resources.confInval + "</div>");
				dialog.dialog({
					appendTo: me.visual,
					resizable: false,
					modal: true,
					height: "auto",
					width: 400,
					dialogClass: "no-close",
					buttons: [
						{
							text: me.resources.yes,
							click: function() {
								me.generate();
								$(this).dialog("close");
							}
						}, {
							text: me.resources.no,
							click: function() {
								$(this).dialog("close");
							}
						}
					]
				});
				$(".ui-dialog").css({ "z-index": 1 });
			} else {
				me.generate();
			}
		}
	} catch (ex) {
		me.writeError('ReportGeneration.btnGenerateClick', ex);
	}
};
ReportGeneration.prototype.createParameterObject = function (loadType) {
	///<summary>
	///prepares the webservice-call object to generate a report <br/>
	///loads the report and loggerid differently depending on the isReports status
	///</summary>
	///<returns>either an empty object or the valid parameter object</returns>
	var me = this;
	var ret;

	try {


		ret = {
			'loadType': loadType,
			"rrid": me.reportId,
			"overrideLastReport": me.visual.find("#chbOverwrite").prop("checked"),
			"loggerid": me.loggerId,
			"toMonth": $.datepicker.parseDate('dd.mm.yy',  me.date),
			"fileName": me.visual.find("#txtCustName").val(),
			"sendEmailToMe": false,
			"fileList": me.fileList,
			"isReports": me.isReports,
			"mailText": me.visual.find("#txtEmail").val()
		}
	} catch (ex) {
		me.writeError('ReportGeneration.createParameterObject', ex);
		ret = new Object();

		console.info(ex);

	}
	return ret;
}
ReportGeneration.prototype.loadUsers = function (isEmail) {
	///<summary>
	///this function is called when a webservice call returns that returns the logger <br/>
	/// e.g. on report selection, or on save of reports
	///</summary>
	var me = this;
	try {

		if (me.visual.find("#us-count").html() > 0) {
			me.createdContent.html("<div class='note loading'>" + me.vcC.getLoadingIcon() + "</div>");
			window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(me.createParameterObject(me.ENUM_CALLS.LOAD_USER)),
				function(result) {
					me.loadUserWS(result, isEmail);
				});
		} else {
			me.createdContent.html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
		}

	} catch (ex) {
		me.writeError('ReportGeneration.loadUsers', ex);

	}
};
ReportGeneration.prototype.loadUserWS = function(result, isEmail) {
	var me = this;
	var dcContent;
	var blid, days, user, errors;
	var inactive;

	try {

		if (result.hasError === false && result.retHTML !==  null && (result.retHTML.rows !== null && result.retHTML.rows.length >=1)) {
		dcContent=   $("<div id='contentList' class='vc-list'></div>");
			blid = $("<ul class='vc-list-selection' style='height:196px; overflow-y:auto;'></div>");
			dcContent.append("<ul class='vc-list-header color-bg-primary' id='lstHeader'><li class='vc-list-item'><div class='vc-list-col'><div class='vc-list-col-element w85 col2'>" + me.resources.username + "<br/> (" + me.resources.email + ")</div><div class='vc-list-col-element w15 col5 text-right' >" + me.resources.options + "</div></div></li></ul>");

			

			for (var i = 0; i < result.retHTML.rows.length; i++) {
				inactive = false;
				days = $("<li class='vc-list-item'></li>");

				if (isEmail && result.retHTML.rows[i].email) {
				   user =$("<div class='vc-list-col' style='cursor:default'><div class='vc-list-col-element w75 col2'><input type='checkbox' style='' class='chkSendTo lg" + result.retHTML.rows[i].report_langid + "' id='" + result.retHTML.rows[i].id + "' data-lang='" + result.retHTML.rows[i].report_langid + "' data-files='" + result.retHTML.rows[i].filetype + "' data-mail='" + result.retHTML.rows[i].usermail + "'/> " + result.retHTML.rows[i].username + "<br/> (" + result.retHTML.rows[i].usermail + ")</div><div class='vc-list-col-element w15 col5 text-right'> " + me.addAssignmentItemSpecifics(result.retHTML.rows[i]) + "</div></div></div>");
				} else if (isEmail === false || (isEmail === true && !result.retHTML.rows[i].email)) {
				   user = $("<div class='vc-list-col' style='cursor:default'><div class='vc-list-col-element w75 col2'>" + result.retHTML.rows[i].username + "<br/> (" + result.retHTML.rows[i].usermail + ")</div><div class='vc-list-col-element w15 col5 text-right'> " + me.addAssignmentItemSpecifics(result.retHTML.rows[i]) + "</div></div></div>");
				   user = $("<div class='vc-list-col' style='cursor:default'><div class='vc-list-col-element w75 col2'>" + result.retHTML.rows[i].username + "<br/> (" + result.retHTML.rows[i].usermail + ")</div><div class='vc-list-col-element w15 col5 text-right'> " + me.addAssignmentItemSpecifics(result.retHTML.rows[i]) + "</div></div></div>");
				}
				errors = $("<div style='float:left; margin-right:5px; height:100%; width:18px;'></div>");
				if (result.retHTML.rows[i].islockedout) {
					errors.append("<i class='fa fa-fw fa-lock icon-color-error' title='"+me.resources.userLocked+"'></i><br/>");
					inactive = true;
				}
				if (! result.retHTML.rows[i].registered) {
					errors.append("<i class='fa fa-fw fa-registered icon-color-error'title='" + me.resources.unregistered + "'></i><br/>");
					inactive = true;
				}
			  
				if (result.retHTML.rows[i].deleted===true) {
					errors.append("<i class='fa fa-fw fa-trash icon-color-error'title='" + me.resources.userDeleted + "'></i><br/>");
					inactive = true;
				}
				if (inactive) {
					days.addClass("err inactive");
					user.find(".chkSendTo").remove();
				} else {
					errors.append("&nbsp;");

				}
				user.prepend(errors);
				days.append(user);
				blid.append(days);
			}
			dcContent.append(blid);
			if (isEmail) { //add the extra email buttons
				dcContent.append("<hr/>");
				dcContent.append("<div class='formOpt'><input type='checkbox' id='chkAll' /><label for='chkAll'>" +me.resources.selectAll +"</label></div>");
				dcContent.append("<div class='formOpt'><input type='checkbox' id='chkDE'/><label for='chkDE'>" +me.resources.selectRcptDE +"</label></div>");
				dcContent.append("<div class='formOpt'><input type='checkbox' id='chkEN' /><label for='chkEN'>" + me.resources.selectRcptEN + "</label></div>");
				dcContent.append("<div class='report-mail-opt'>" +"<div class='note error' style='visibility:hidden;' id='emailsend'>" +me.resources.mailSentError +"</div>");
				dcContent.append("");
				dcContent.append("<div class='formOpt large'><label for='txtEmail'>" + me.resources.emailText + " (opt.)</label><br/><textarea rows='4' cols='50' id='txtEmail' type='textarea' class='txtEnabled fields formItemValid'></textarea></div>");
				dcContent.append("</div>");
				dcContent.append("</div>");
				dcContent.append("<div id='btnSend' class='btnMainItem' style='top:0'><i class='fa fa-envelope'></i><br/>" +me.resources.send +"</div>");
			}
			me.createdContent.html(dcContent);
			if (isEmail) {
                me.visual.find("#btnSend").button().off("click").on("click", function () { me.btnSendEmailClick(me, this) });
				me.visual.find("#chkAll").off("change").on("change",function() { me.toggleEmailCheckboxes(me, this, ".chkSendTo, #chkEN, #chkDE"); });
				me.visual.find("#chkEN").off("change").on("change",function() { me.toggleEmailCheckboxes(me, this, ".chkSendTo.lg3"); });
				me.visual.find("#chkDE").off("change").on("change",function() { me.toggleEmailCheckboxes(me, this, ".chkSendTo.lg2"); });
				//dcContent.find(".vc-list-selection .vc-list-item:even").addClass("alt");
			}
			dcContent.find(".vc-list-selection .vc-list-item:even").addClass("alt");

		} else {
			if (result.hasError === true) {
				me.showInfo(result.retHTML, "", true);
			} else {
				me.createdContent.html("<div class='note'>" + me.resources.noEntriesExist + "</div>");

			}
		}
	} catch (ex) {
		me.writeError('ReportGeneration.loadUserWS', ex);
	}
};
ReportGeneration.prototype.toggleEmailCheckboxes = function(me, checkbox, selector) {
	///<summary>
	///handles the selection of the email checkboxes with the different selectors
	///</summary>
	try {
		me.visual.find(selector).each(function(ix, element) { element.checked = checkbox.checked });

	} catch (ex) {
		me.writeError('ReportGeneration.toggleEmailCheckboxes', ex);

	}
};
ReportGeneration.prototype.btnSendEmailClick = function(me, element) {
	///<summary>
	///this function is  when an email is to be sent <br/>
	///</summary>
	var emails, ids, $testme;
	try {
		if (!$(element).button("option", "disabled")) {
			emails = [];
			ids = [];
			$testme = me.visual.find(".chkSendTo");
			me.visual.find("#emailsend").css({ "visibility": "hidden" });
			if ($testme.length >= 1) {
				$testme.each(function(idx, element) {
					if (element.checked) {
						emails.push({
							"LangId": $(element).data("lang"),
							"FileTypes": $(element).data("files"),
							"Email": $(element).data("mail"),
							"Uid": $(element).attr("id")
						});
						ids.push($(element).attr("id"));
					}
				});
				if (emails.length > 0) {
					window.VisualCoreService.getData(me.vcvid,
						me.vcgid,
						window.getCurrentTimestamp(),
						0,
						0,
						"a",
						JSON.stringify(emails),
						me.deviceType,
						me.langid,
						JSON.stringify(me.createParameterObject(me.ENUM_CALLS.SEND_MAIL)),
						function(result) {
							if (result.retHTML === true) {
								ids.forEach(function(el) {
									me.visual.find(".chkSendTo[id=" + el + "]")
										.replaceWith(
											"<i class='fa fa-check icon-color-ok report-mail-sent-sucess'></i>");
								});
								me.visual.find("#emailsend").html(me.resources.mailSentSucess).removeClass("error")
									.css({ "visibility": "visible" });
								if (me.visual.find(".chkSendTo").length === 0) {
									me.visual.find("#btnSend").button({ "disabled": true });
									me.visual.find(".report-mail-opt").toggle(false);

								}
							} else {
								me.visual.find("#emailsend").addClass("error").html(me.resources.mailSentError)
									.css({ "visibility": "visible" });
							}
						});
				} else {
					me.visual.find("#emailsend").addClass("error").html(me.resources.noEmailRec)
						.css({ "visibility": "visible" });

				}
			} else {
				me.visual.find("#emailsend").html(me.resources.mailSentSucess).removeClass("error")
					.css({ "visibility": "visible" });
				me.visual.find(".wizard-step.s4").removeClass("active color-border-secondary color-bg-secondary")
					.addClass("done color-border-primary color-bg-primary")
					.prepend("<i class='fa fa-check' style='font-size:1.3em'></i> ");
			}
		}

	} catch (ex) {
		me.writeError('ReportGeneration.btnSendEmailClick', ex);

	}
};



ReportGeneration.prototype.fillLoggerList = function (result, lastId) {
	///<summary>
	///this function is called when a webservice call returns that returns the logger <br/>
	/// e.g. on report selection, or on save of reports
	///</summary>
	var me = this;
	var date;
	try {
		var sTmp;
		//
	
		if (result === null) {
			me.visual.find("#logger").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
			return false;
		}
		if (result.rows === null) {
			me.visual.find("#logger").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
			return false;
		}
		sTmp = "";
		for (var i = 0; i < result.rows.length; i++) {
			date = window.Highcharts.dateFormat("%d.%m.%Y %H:%M", (result.rows[i].last));

			sTmp += "<li class='vc-list-item ui-widget-content";
		  

			sTmp += "' data-id='" + result.rows[i].blid + "' data-user='" + result.rows[i].usercount + "' data-anno='" + result.rows[i].annocount + "' data-only-main='" + result.rows[i].only_main_signals + "' data-overwrite='" + result.rows[i].overwrite + "'>";
			window.Highcharts.setOptions({global: {useUTC: false}});
		 //   if (result.rows[i].last) {
			//	//if (result.rows[i].last && result.rows[i].last.getMonth() === new Date().getMonth()) {
			//	//	sTmp += "<i class='fa fa-envelope  icon-color-info fa-2x' style='float:left; margin-right:5px;' title='"+ me.resources.done + "'></i>";
			//	//} else {
			//	//	sTmp += "<i class='fa fa-envelope-open icon-color-info fa-2x' style='float:left; margin-right:5px;' title='" + me.resources.notDone + "'></i>";

			//	//}
			//	sTmp += "<div class='report-logger-name'>" + result.rows[i].name + "</div><div class='report-last-generated'>" + me.resources.lastChange + ": " + window.Highcharts.dateFormat("%d.%m.%Y %H:%M", (result.rows[i].last)) + "</div></li>";
			//} else {
				//sTmp += "<i class='fa fa-envelope-open icon-color-info fa-2x' style='float:left; margin-right:5px;' title='" + me.resources.notDone + "'></i>";

				sTmp += "<div class='report-logger-name'>"+result.rows[i].name + "</div></li>";
			//}
			window.Highcharts.setOptions({global: {useUTC: true}});
		}
		me.visual.find("#logger").html(sTmp);

		if (lastId) {
			me.visual.find("#logger .vc-list-item[data-id=" + lastId + "]").addClass("button-toggle-active");
			me.visual.find("#create").show();
		}

		me.visual.find("#logger .vc-list-item").off("click")
			.on("click", function () { me.selectProject(me, this); });
		me.filter();

		return true;
	} catch (ex) {
		me.writeError('ReportGeneration.initClickHandler', ex);
		return false;
	}
};

ReportGeneration.prototype.fillReportList = function (result, lastId) {
	///<summary>
	///this function is called when a webservice call returns that returns the reports for the given logger  <br/>
	///</summary>
	var me = this;
	try {
		me.visual.find("#lst-reports").html("");
		
		var sTmp;
		if (result === null) {
			me.visual.find("#lst-reports").html("<div class='note'>"+ me.resources.noEntriesExist + "</div>");
			return false;
		}
		if (result.rows === null) {
			me.visual.find("#lst-reports").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
			return false;
		}
		me.visual.find("#lst-reports > li").remove();



		for (var i = 0; i < result.rows.length; i++) {

			sTmp = "<li class='vc-list-item ui-widget-content'";
			sTmp += "data-period='" + result.rows[i].month_period + "' data-rrid='" + result.rows[i].rrid + "'  data-only-main='" + result.rows[i].only_main_signals + "' data-user='" + result.rows[i].usercount + "' data-anno='" + result.rows[i].annocount + "'  data-overwrite='" + result.rows[i].overwrite + "'>";
			window.Highcharts.setOptions({global: {useUTC: false}});

			if (result.rows[i].autoreport) {
				sTmp += "<div style='opacity:0.4'>"; 
				sTmp += "<i class='fa fa-circle-envelope icon-color-ok fa-2x' style='float:left; margin-right:5px;' title='auto-send'></i>";
				sTmp += "<div class='report-logger-name'>" + result.rows[i].name + "</div>";
				sTmp += "<div class='report-last-generated'>" + me.resources.lastChange + ": " + window.Highcharts.dateFormat("%d.%m.%Y %H:%M", (result.rows[i].last)) + "</div></li>";
				sTmp += "</div>"; 

			} else {
				if (result.rows[i].last) {
					if (result.rows[i].last && result.rows[i].last.getMonth() === new Date().getMonth()) {
						sTmp += "<i class='fa fa-envelope icon-color-info fa-2x' style='float:left; margin-right:5px;' title='" + me.resources.done + "'></i>";
					} else {
						sTmp += "<i class='fa fa-envelope-open  icon-color-info fa-2x' style='float:left; margin-right:5px;' title='" + me.resources.notDone + "'></i>";
					}

					//sTmp += "<i class='fa fa-envelope icon-color-info fa-2x' style='float:left; margin-right:5px;' title='" + me.resources.done + "'></i>";
					sTmp += "<div class='report-logger-name'>" + result.rows[i].name + "</div>";
					sTmp += "<div class='report-last-generated'>" + me.resources.lastChange + ": " + window.Highcharts.dateFormat("%d.%m.%Y %H:%M", (result.rows[i].last)) + "</div></li>";
				} else {
					sTmp += "<i class='fa fa-envelope-open icon-color-info fa-2x' style='float:left; margin-right:5px;' title='" + me.resources.notDone + "'></i>";

					sTmp += "<div class='report-logger-name'>" + result.rows[i].name + "</div></li>";
				}
			}


			window.Highcharts.setOptions({ global: { useUTC: true } });
			me.visual.find("#lst-reports").append(sTmp);
		}
		if (lastId) {
			me.visual.find("#lst-reports .vc-list-item[data-rrid=" + lastId + "]").addClass("button-toggle-active");
			me.visual.find("#create").show();
		}



	
		me.visual.find("#lst-reports .vc-list-item").off("click")
			.on("click", function () { me.selectReport(me, this); });
		//me.filter();

		return true;
	} catch (ex) {
		me.writeError('ReportGeneration.initClickHandler', ex);
		return false;
	}
};
ReportGeneration.prototype.generate = function () {
	///<summary>
	///this function calls the webservice to generate a report and creates the list <br/>
	/// e.g. on report selection, or on save of reports
	///</summary>
	var me = this;
	var lastId;
	try {
		me.wiz.vcWizard("setActive", me.ENUM_STEPS.SAVE);
		me.createdContent.html("<div class='note loading'>" + me.resources.generateReportPleaseWait + "</div>");
		me.visual.find("#btnGenerate").button("disable");
		//if (me.isReports) {
		//	lastId = me.visual.find("#logger .vc-list-item.button-toggle-active").data("id");

		//} else {
			lastId = me.visual.find("#lst-reports .vc-list-item.button-toggle-active").data("rrid");

		//}
		if (lastId) {
			window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(me.createParameterObject(me.ENUM_CALLS.GENERATE)),
				function (result) {
					var res = result;
					if (res.hasError === false) {
						me.createdContent.html("");

						me.fileList = res.retHTML;


						me.createdContent.append(me.buildLanguageField(me.resources.german,"de",jQuery.grep(res.retHTML, function(el) { return el.language === "de"; }),me._FILEICONS));
						me.createdContent.append(me.buildLanguageField(me.resources.english, "en", jQuery.grep(res.retHTML, function (el) { return el.language === "en"; }), me._FILEICONS));
						me.createdContent.append(me.buildLanguageField(me.resources.italian, "it", jQuery.grep(res.retHTML, function (el) { return el.language === "it"; }), me._FILEICONS));
						me.createdContent.append(me.buildLanguageField(me.resources.croatian, "hlv", jQuery.grep(res.retHTML, function (el) { return el.language === "hlv"; }), me._FILEICONS));
						me.createdContent.append(me.buildLanguageField(me.resources.polish, "pl", jQuery.grep(res.retHTML, function (el) { return el.language === "pl"; }), me._FILEICONS));
						me.createdContent.append(me.buildLanguageField(me.resources.czech, "cz", jQuery.grep(res.retHTML, function (el) { return el.language === "cz"; }), me._FILEICONS));
						me.visual.find(".report-generated-language .vc-list-item:odd").addClass("alt");
                           					    me.createdContent.append("<div id='testSave'></div>");

						//if (parseInt(me.visual.find("#us-count").html(), 10) >= 1) {


							me.createdContent.append("<div id='btnSaveInfo' class='note'>" + me.resources.saveInfo + "</div>");
							me.createdContent.append("<div id='btnSave' class='btnMainItem' ><i class='fa fa-save'></i><br/>" +me.resources.save +"</div>");
							me.visual.find("#btnSave").button().off("click").on("click",
								function() {
									if (!$(this).button("option", "disabled")) {
										me.visual.find("#btnSave").button("disable");
										//me.visual.find("#logger").html("<div class='note'>" + me.vcC.getLoadingIcon() + "</div>");

										window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(me.createParameterObject(me.ENUM_CALLS.SAVE)),
											function (result) {
												if (result.hasError === false) {
													me.visual.find("#logger .vc-list-item[data-id=" + lastId + "]").addClass("button-toggle-active");
													me.loadUsers(true);
												
														me.fillReportList(result.retHTML, lastId);
													me.wiz.vcWizard("setActive", me.ENUM_STEPS.SEND_MAIL);
												

												} else {
													me.showInfo(result.retHTML, "", true);
												}
												return true;
											}
										);
									}
								});
						//} else {
							//me.createdContent.append("<div id='btnSaveInfo' class='note'>" + me.resources.reportNoUserSaveInfo + "</div>");
						//}
					} else {
						me.visual.find("#report-generation-created-content").html("<div class='note error'>" + res.retHTML + "</div>");
					}
				});

		} else {
			me.visual.find("#report-generation-created-content").html("<div class='note error'>" + me.resources.reportNothingSelectedToGenerate_lbl + "</div>");

		}
	} catch (ex) {
		me.writeError("CustomerDetails.generate", ex);
	}
};
ReportGeneration.prototype.buildLanguageField = function (langNameLong, langNameShort, files, fileIcons) {
	/// <summary>
	/// This function builds the languageField for the download of files
	/// </summary>
	var me = this;
    var fileField = "";
    var filePathRelative = "";
	try {
		if (files.length > 0) {
			fileField = $("<ul class='vc-list-selection report-generated-language' id='lang" + langNameShort + "'>");
			fileField.append("<legend>" + langNameLong + "</legend>");
            for (var i = 0; i < files.length; i++) {
                filePathRelative = "/tmp/" + files[i].Path.split("\\")[files[i].Path.split("\\").length - 1] + "." + files[i].type;
                fileField.append("<li class='vc-list-item '><a class='report-file-link " + files[i].type + "' id='" + files[i].type + langNameShort + "' onclick='downloadMediaDataUrl(\"" + filePathRelative +"\");' style='cursor: pointer;' ><div class='report-generated-file'>" + fileIcons[files[i].type] + " " + files[i].name + "." + files[i].type + "<i class='fa  fa-download fa-2x report-download'></i></div></div></a></li>");
			}
		}
	} catch (ex) {
		me.writeError("ReportGeneration.buildLanguageField", ex);
		fileField = "";
	}
	return fileField;
}
ReportGeneration.prototype.addAssignmentItemSpecifics = function (row) {
	/// <summary>
	/// This function inits the assigment specific icons if implemented
	/// </summary>
	///<param name='row'> a row object to add the item </param>
	var me = this;
	var sTmp = "";
	var bPDF, bXLS;
	try {

		
		if (me.error) { return false; }
		bPDF = (row.filetype & 1) === 1;
		bXLS = (row.filetype & 2) === 2;
		if (row.email) {
			sTmp += "<i class='fa fa-envelope fa-fw icon-color-info' title='" + me.resources.email + "'></i>";
		}
		if (bPDF) {
			sTmp += "<i class='fa fa-file-pdf fa-fw icon-color-info' title='PDF'></i>";
		}
		if (bXLS) {
			sTmp += "<i class='fa fa-file-excel fa-fw icon-color-info' title='XLS'></i>";
		}
		
		sTmp += "&nbsp;" + row.langshortcut;
	
		return sTmp;
	} catch (ex) {
		me.writeError('MSAssignmentReportLoggerUser.addAssignmentmentItemSpecifics', ex);
		return false;
	}
};
ReportGeneration.prototype.specificInfoHandling = function (bError) {
	/// <summary>
	/// This function  hides/fades out content on error state. 
	/// </summary>
	var me = this;
	try {
		if (bError) {
			me.visual.find("#report-button-switch-view, .report-generation-reports, #vc-wizard-report-gen, .report-main-content").hide();
		}
		return true;
	} catch (ex) {
		me.writeError("ReportGeneration.specificInfoHandling", ex);
		return false;
	}
};
//ReportGeneration.prototype.getSignalErrorTree = function (element, bOnlyMain) {
//	///<summary>
//	///This function loads the signaltree after validation and if errors are there <br/>
//	///by click on a list item - mostly taken from AFU in Datacenter
//	///</summary>
//	var me = this;
//	try {
//	 var errorTreePar = {
//			'loggerid': $(element).data("id"),
//			'day': $(element).data("day"),
//			'EditMode': false,
//			"MainSignalsOnly": bOnlyMain
//		};
//		window.showModalPopup("<div id='divSignalTree1'></div>", 610, 770);
//		me.vcVisual.addVisualBaseByName("divSignal", "VISUAL_DATACENTER_SIGNALTREE", "Tree1", window.getCurrentTimestamp(), 750, 600, JSON.stringify(errorTreePar), "", 1);
//		return false;
//	} catch (ex) { me.writeError("ReportGeneration.getSignalErrorTree", ex); return false; }
//};

ReportGeneration.prototype.filter = function () {
	/// <summary>
	/// This function adds/removes two css-classes ('found' and 'exclude') for filtering analog signals.<br/>
	/// When a signal with a filter expression gets found the 'found' class gets added <br/>
	/// At the end, basically all 'found' classes get shown and all others hidden. The core of this function is taken from ARF<br/>
	/// </summary>
	var bRet = true;
	var me = this;
	try {
		if (me.error) {
			bRet = false;
		} else {

			//hide all
			me.visual.find(".vc-list-selection .vc-list-item").removeClass("found").data("counter", 0).hide();

			//we add the 'found' class to all items we want to filter based on the vcfilter tags
			me.setTagFilter(".vc-filter", ".vc-list-selection  .vc-list-item", "found");
			me.visual.find(".vc-list-selection  .vc-list-item.found").show();
			me.visual.find(".vc-list-selection  .vc-list-item").removeClass("alt");
			me.visual.find(".vc-list-selection .vc-list-item.found:even").addClass("alt");            ////get a list of filter expressions

		}
	} catch (ex) {
		me.writeError('subSignalMenu.filter', ex);
		bRet = false;
	}
	return bRet;
};

//#END REGION FILTER

